export const ACCOUNT_DOMAIN = 'app/modules/Account/ACCOUNT_DOMAIN';
export const ACCOUNT_FETCH_BALANCES = 'app/modules/Account/ACCOUNT_FETCH_BALANCES';